import { colors } from '../../colors';
var location = {
  bgColor: colors.eggShell,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black
};
export default location;